import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=3e9edb3c&scoped=true"
import script from "./Followers.vue?vue&type=script&lang=js"
export * from "./Followers.vue?vue&type=script&lang=js"
import style0 from "./Followers.vue?vue&type=style&index=0&id=3e9edb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9edb3c",
  null
  
)

export default component.exports